import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'tidy-small-round-button',
  templateUrl: './small-round-button.component.html',
  styleUrls: ['./small-round-button.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class TidySmallRoundButtonComponent {
  @Input() buttonClass = '';
  @Input() icon = '';
  @Input() image = '';
  @Input() selected = false;
  @Output() buttonClick = new EventEmitter<void>();
}
